import { Box, Button } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import RouterConstants from "../../../constants/RouterConstants.ts";
import { CrmEventTargets, CrmOrgEvents, CrmUserEvents } from "../../../constants/crm.ts";
import { getSelectedOrganization } from "../../../helpers/localStorage.ts";
import useSecureNavigate from "../../../hooks/useSecureNavigate.tsx";
import { useAppStore } from "../../../hooks/useStores.tsx";
import styles from "./ImageEditingMcpServerBanner.module.scss";

const ImageEditingMcpServerBanner = () => {
    const { t } = useTranslation("translation", { keyPrefix: "McpServerBanner" });
    const navigate = useSecureNavigate();
    const { authStore, appStore } = useAppStore();
    const user = authStore?.user;
    const selectedOrg = getSelectedOrganization();
    const [showMcpServerBanner, _setShowMcpServerBanner] = useState(true);

    const handleClick = async () => {
        if (!user) return;
        navigate(RouterConstants.IMAGE_EDITING.McpSERVER.fullPath);

        const baseProperties: any = {
            user_name: user.userName,
            user_email: user.email,
            ...(selectedOrg && { org_name: selectedOrg.organization.name! }),
        };

        const crmEventsPayload: any = [
            {
                properties: baseProperties,
                eventTarget: CrmEventTargets.USER,
                eventType: CrmUserEvents.USER_CLICKED_ON_MCP_SERVER_BANNER,
            },
        ];

        if (selectedOrg) {
            crmEventsPayload.push({
                properties: baseProperties,
                eventTarget: CrmEventTargets.ORG,
                eventType: CrmOrgEvents.ORG_CLICKED_ON_MCP_SERVER_BANNER,
            });
        }

        await appStore.logCrmEvents(crmEventsPayload);
    };

    return (
        <>
            {showMcpServerBanner && user && selectedOrg && (
                <Box className={styles.mcpServerBannerContainer} >
                    <Button onClick={handleClick} sx={{ cursor: "pointer" }}  className={styles.mcpServerBannerButton} >
                        {t("title")}
                    </Button>
                </Box>
            )}
        </>
    );
};

export default observer(ImageEditingMcpServerBanner);